import { PollOption } from '@queries/getPoll';
import React from 'react';
import Button from '../Button';
import ButtonOutlined from '../ButtonOutlined';
import { PollOptionsContainer, Row } from './styles';

type Props = {
  pollOptions: PollOption[];
  onAnswerClick: (documentId: string) => void;
  activeOption: string | null;
};

const PollOptionsRenderer = ({
  pollOptions,
  activeOption,
  onAnswerClick,
}: Props) => {
  return (
    <PollOptionsContainer>
      {pollOptions.map(({ option, documentId }) => (
        <Row key={documentId}>
          {activeOption === documentId ? (
            <Button fontSize={14} title={option} />
          ) : (
            <ButtonOutlined
              title={option}
              onClick={() => onAnswerClick(documentId)}
            />
          )}
        </Row>
      ))}
    </PollOptionsContainer>
  );
};

export default PollOptionsRenderer;
